import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import logo from '../traderhub24-logo.svg'
import Footer from './components/Footer'

export default function NotFound() {
  const navigate = useNavigate()
  const { t } = useTranslation('common')

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="min-h-screen bg-app-bg text-gray-900">
      <header className="w-full py-3 px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-4">
          <img
            src={logo}
            alt="TraderHub24"
            className="h-12 md:h-20 w-auto cursor-pointer hover:opacity-80 transition-opacity"
            onClick={() => navigate('/')}
          />
          <button
            onClick={() => navigate('/')}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
          >
            {t('nav.home')}
          </button>
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-20">
        <div className="bg-app-box shadow-sm border border-gray-200 rounded-2xl p-8 md:p-16 text-center">
          <h1 className="text-6xl md:text-8xl font-bold text-gray-300 mb-4">404</h1>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
            {t('notFound.title')}
          </h2>
          <p className="text-gray-600 mb-8 max-w-md mx-auto">
            {t('notFound.message')}
          </p>
          <button
            onClick={() => navigate('/')}
            className="px-6 py-3 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-lg transition-colors"
          >
            {t('notFound.goHome')}
          </button>
        </div>
      </main>

      <Footer
        currentPage="home"
        onNavigate={(page) => {
          if (page === 'home') navigate('/')
          else if (page === 'changelog') navigate('/changelog')
          else if (page === 'pricing') navigate('/pricing')
          else if (page === 'privacy-policy') navigate('/privacy')
          else if (page === 'terms-and-conditions') navigate('/terms')
          else if (page === 'risk-warning') navigate('/risk-warning')
          else if (page === 'documentation') navigate('/documentation')
          else if (page === 'contact') navigate('/contact')
        }}
      />
    </div>
  )
}
